// extracted by mini-css-extract-plugin
module.exports = {"title":"BrowseMediaFacetDialog_title__FiDtV","body":"BrowseMediaFacetDialog_body__2626O"};